import { useMobileDetector } from '@/hooks/use-mobile-detector'
import clsx from 'clsx'
import { FC } from 'react'
import TagItem from '@/components/standard/tag-item'
import { SemanticTextTag } from '@/common/pd-meta-components-types'

type Section3Type = {
  dataList: Array<{
    mediaUrl: string
    title: string
    desc?: string
  }>
  theme?: string
  itemTitleTag?: SemanticTextTag
}
const Section3: FC<Section3Type> = ({ dataList, theme, itemTitleTag }) => {
  const isMobile = useMobileDetector()
  return (
    <div className={clsx('w-full h-fit relative', 'py-15 laptop:py-30', `pd-theme-${theme} bg-anti-blk`)}>
      <div
        className={clsx('w-full max-w-300 mx-auto', 'gap-6', 'grid grid-cols-2 laptop:grid-cols-4', 'px-6 laptop:px-0')}
      >
        {dataList.map((item, index) => (
          <TagItem key={index} {...item} contentAlign={isMobile ? 'left' : 'center'} titleTag={itemTitleTag} />
        ))}
      </div>
    </div>
  )
}

export default Section3
